/**
 * Adds a small "Embroidered" / "Printed" pill to product card titles —
 * same mechanism as clvry-edition-pill.js (MutationObserver over
 * .card__heading, so it survives dynamically-loaded/re-rendered markup
 * like AJAX cart/quick-view), but keyed off the product handle (parsed
 * from the card's own link, same technique clvry-card-mockups.js
 * already uses) rather than parsing the title text — there's no natural
 * "— Embroidered" suffix in these product titles the way Blackout/
 * Whiteout Edition already has one.
 *
 * TECHNIQUE_BY_HANDLE mirrors the real production technique each
 * product actually uses in worker/src/products.js (frontLogoPosition:
 * "embroidery_*" vs DTF/DTG print positions) — keep the two in sync
 * if a product's technique ever changes there.
 */
(function () {
  // Polo/Sweatshirt (+ Blackout/Whiteout) switched embroidery -> DTF
  // 2026-09-26/30 — see the doc comments on PRODUCTS.Polo/.Sweatshirt in
  // worker/src/products.js. Cap followed (front_dtf_hat) 2026-10-07, so
  // nothing in the store is embroidered anymore.
  // Every product is printed now, so a "Printed" pill told customers nothing
  // (and cluttered the cards). Left empty on purpose: add a handle here, e.g.
  // "clvry-example": "embroidered", if a product ever uses a different technique.
  var TECHNIQUE_BY_HANDLE = {};
  var LABEL = { embroidered: "Embroidered", printed: "Printed" };

  function processHeading(el) {
    if (el.dataset.clvryTechniquePill) return;
    var a = el.tagName === "A" ? el : el.querySelector('a[href*="/products/"]');
    if (!a) return;
    el.dataset.clvryTechniquePill = "done";

    var handle = a.getAttribute("href").split("/products/")[1];
    if (!handle) return;
    handle = handle.split(/[?#]/)[0];
    var technique = TECHNIQUE_BY_HANDLE[handle];
    if (!technique) return;

    var pill = document.createElement("span");
    pill.className = "clvry-technique-pill clvry-technique-pill--" + technique;
    pill.textContent = LABEL[technique];

    // If an edition pill (Blackout/Whiteout Edition) already sits in
    // this heading, group both pills into one wrapping unit so they
    // always move to the next line TOGETHER when the title is too long
    // to fit — otherwise the two pills wrap independently, leaving this
    // one stranded alone on its own line under a longer product name
    // like "CLVRY Sweatshirt".
    var editionPill = a.querySelector(".clvry-edition-pill");
    if (editionPill) {
      var group = document.createElement("span");
      group.className = "clvry-pill-group";
      editionPill.parentNode.insertBefore(group, editionPill);
      group.appendChild(editionPill);
      group.appendChild(pill);
    } else {
      a.appendChild(pill);
    }
  }

  function init() {
    document.querySelectorAll(".card__heading").forEach(processHeading);
  }

  init();
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();
